import type { WaypointPosition } from './types';

/**
 * Calculates the position of the waypoint relative to the viewport
 */
export function calculatePosition(entry: IntersectionObserverEntry): WaypointPosition {
	const rect = entry.boundingClientRect;
	const viewportHeight = window.innerHeight;

	if (rect.bottom < 0) {
		return 'above';
	}
	if (rect.top > viewportHeight) {
		return 'below';
	}
	return 'inside';
}
